/**
 * Real-time Service for Web App
 * Connects to Supabase realtime for live updates
 */

import { supabase } from './supabaseClient';

export class RealtimeService {
  static subscriptions = new Map();

  /**
   * Subscribe to service_requests table changes
   */
  static subscribeToServiceRequests(callback) {
    // Remove existing subscription if any
    this.unsubscribe('service_requests');

    const channel = supabase
      .channel('service_requests_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'service_requests',
        },
        (payload) => {
          console.log('Service request change:', payload);
          callback(payload);
        }
      )
      .subscribe();

    this.subscriptions.set('service_requests', channel);
    return channel;
  }

  /**
   * Subscribe to myfng_complaints table changes
   */
  static subscribeToMyFNGComplaints(userId, callback) {
    const key = `myfng_complaints_${userId}`;
    this.unsubscribe(key);

    const channel = supabase
      .channel(`myfng_complaints_${userId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'myfng_complaints',
          filter: `registered_by=eq.${userId}`,
        },
        (payload) => {
          console.log('MyFNG complaint change:', payload);
          callback(payload);
        }
      )
      .subscribe();

    this.subscriptions.set(key, channel);
    return channel;
  }

  /**
   * Unsubscribe from a channel
   */
  static unsubscribe(key) {
    const channel = this.subscriptions.get(key);
    if (channel) {
      supabase.removeChannel(channel);
      this.subscriptions.delete(key);
    }
  }

  /**
   * Unsubscribe from all channels
   */
  static unsubscribeAll() {
    this.subscriptions.forEach((channel, key) => {
      supabase.removeChannel(channel);
    });
    this.subscriptions.clear();
  }
}

